import React from 'react';
import { AvProjIconTag } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box, SxProps } from '@mui/material';

export const Entities = ({
  users,
  assets,
  showText = false,
  onClick,
  sx,
}: {
  users: number;
  assets: number;
  showText?: boolean;
  onClick?: () => void;
  sx?: SxProps;
}) => (
  <Box sx={{ ...flex.itemsCenter, gap: '8px', ...sx }} onClick={onClick}>
    <AvProjIconTag projName="uber_users" total={users} includeProjName={showText} />
    <AvProjIconTag projName="uber_assets" total={assets} includeProjName={showText} />
  </Box>
);
